import {Certificate} from './types';

// FNP-1299 — WHO MAY DELETE WHAT, AS TWO PURE FUNCTIONS.
//
// ⚠️ EXTRACTED FROM `CertificatesTable` SO IT CAN BE TESTED AT ALL.
//
// `mantine-datatable` emits no data cells and no real header text under jsdom —
// verified against both the shared wrapper and the raw library component, and
// documented at the top of `tests/certificatesTable.test.tsx`. So a test cannot
// assert "the Actions column is present" by reading the rendered table; it can
// only assert the DECISION the table makes before rendering. These two
// functions are that decision, and the table calls nothing else to make it.
//
// ⚠️ TWO QUESTIONS AT TWO SCOPES, AND CONFLATING THEM IS THE BUG THIS FIXES.
//
//   canDeleteAnything  — a question about the TABLE. Should the Actions column
//                        exist at all? No connection can delete, no column.
//   isRowDeletable     — a question about the ROW. A bulk-capable table renders
//                        rows from several connections at once, so the column
//                        existing says nothing about any particular row.
//
// Before this, both were answered from the REQUEST connection list. That was
// exact by accident: until FNP-1280 the backend set `canRequest` and
// `canDelete` from one `writable` flag, so either question gave the same
// answer. They are now separate declarations — `acm:RequestCertificate` and
// `acm:DeleteCertificate` are separate statements in the tenant's own role — so
// a tenant can hold either without the other, and asking the request list both
// offered a delete the API refuses AND withheld one it would have allowed.

/**
 * Should the Actions column exist? True when ANY connection may delete.
 *
 * ⚠️ Takes the id SET rather than the connection list, because that is what the
 * table already holds and building a second shape here would let the two drift.
 */
export const canDeleteAnything = (deletableConnectionIds: ReadonlySet<string>): boolean =>
    deletableConnectionIds.size > 0;

/**
 * May THIS certificate be deleted?
 *
 * ⚠️ Keyed on the certificate's OWN `connectionId`, which is the only honest
 * way to ask: the certificate was issued through one connection and that is the
 * connection whose grant governs its deletion.
 */
export const isRowDeletable = (
    certificate: Certificate,
    deletableConnectionIds: ReadonlySet<string>,
): boolean => deletableConnectionIds.has(certificate.connectionId);
